export default __webpack_public_path__ + "static/media/dubbed.6fa7af51.svg";